import dayjs from "dayjs";

import {
  TableMobileHeader,
  TableMobileRow,
  TableMobileRowProps,
} from "../../../Table";
import { formatCurrencyWithSymbol } from "../../../utils/currency";
import { COLUMN_DATE_FORMAT } from "../../ClientAccountReport";
import { FundedNotTradedRow } from "../../types";
import { ClientFundedNotTradedTableConfigType } from "./types";

export const MobileCardHeader =
  ({ language, translatedContent }: ClientFundedNotTradedTableConfigType) =>
  (row: FundedNotTradedRow) => {
    const {
      depositedAt,
      depositedAmount,
      currencyCode,
      clientID: clientId,
    } = row;

    const clientIdConfig = {
      value: clientId,
      label: translatedContent.clientId,
    };

    const subHeaderRows: TableMobileRowProps[] = [
      {
        label: translatedContent?.depositAmount ?? "",
        value: formatCurrencyWithSymbol(
          depositedAmount,
          currencyCode,
          language,
        ),
      },
      {
        label: translatedContent?.depositDate ?? "",
        value: depositedAt
          ? dayjs(depositedAt).format(COLUMN_DATE_FORMAT)
          : "-",
      },
    ];

    return (
      <TableMobileHeader
        clientId={clientIdConfig}
        subHeaderRows={subHeaderRows}
      />
    );
  };

export const MobileCardBody =
  ({ translatedContent }: ClientFundedNotTradedTableConfigType) =>
  (row: FundedNotTradedRow) => {
    const {
      accountID: accountId,
      accountType,
      rebateAccountID: rebateAccount,
    } = row;

    return (
      <>
        <TableMobileRow
          label={translatedContent.acc + " #"}
          value={accountId}
        />
        <TableMobileRow label={translatedContent.accType} value={accountType} />
        <TableMobileRow
          label={translatedContent.rebateAccount}
          value={rebateAccount}
        />
      </>
    );
  };
